export default "__VITE_ASSET__tlO5ac0M__"